/**
 * User: Rob Richard
 * Date: 8/7/14
 * Time: 12:01 PM
 */

'use strict';

var $ = require('dibs-jquery-shim');
var SoaModel = require('bunsen/models/SoaModel');
var root = typeof window === 'undefined' ? global : window;
root.bunsen = root.bunsen || {};
var FinancialAmount = module.exports = root.bunsen.FinancialAmount = SoaModel.extend();
var price = require('bunsen/libraries/helpers/price');
var numberConversions = require('bunsen/helpers/numberConversions');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var CurrencyConversionRateEvent = require('bunsen/models/ecomm/CurrencyConversionRateEvent');
var currencies = require('dibs-currency-helpers/currencies');
var getCurrencySymbol = require('dibs-currency-helpers/getCurrencySymbol');
var currencyConstants = require('dibs-currency-helpers/constants').currencies;

_.extend(FinancialAmount, {
    getCurrencies: function () {
        return currencies;
    },
    getCurrencySymbol: getCurrencySymbol
}, currencyConstants);

_.extend(FinancialAmount.prototype, {
    initialize: function () {
        this.on('change:amount', this.updateConvertedAmounts, this);
        if (!this.get('convertedAmounts')) {
            this.updateConvertedAmounts();
        }

        _.each(currencies, function (currency) {
            this['is' + currency] = _.partial(this.isCurrency, currency);
        }, this);
    },
    relations: SoaModel.createRelations([
        'convertedAmounts',
        {
            key: 'conversionRateEvent',
            type: Backbone.One,
            relatedModel: CurrencyConversionRateEvent
        }
    ]),
    getCurrency: function () {
        return this.get('currency');
    },
    isCurrency: function (currency) {
        return this.get('currency') === currency;
    },
    getAmountIn: function (currency) {
        // we don't need converted amounts when it's zero
        if (this.get('amount') === 0) {
            return 0;
        }
        return this.get('convertedAmounts.' + currency);
    },
    updateConvertedAmounts: function (options) {
        var convertedAmountsObj = {};
        options = _.defaults(options || {}, {
            removeConvertedAmounts: true
        });
        if (!options.removeConvertedAmounts) {
            return;
        }
        if ($.isNumeric(this.get('amount')) && !$.isEmptyObject(this.get('currency'))) {
            convertedAmountsObj[this.get('currency')] = this.get('amount');
            this.set('convertedAmounts', convertedAmountsObj);
        } else {
            this.unset('convertedAmounts');
        }
    },
    getDisplayPrice: function(currency) {
        currency = currency || this.getCurrency();
        return price.formatPrice(this.getAmountIn(currency), currency);
    },
    getStatementAmount: function () {
        var currency = this.get('currency');
        var numericAmount = this.safeNegate().getAmountIn(currency);
        return numberConversions.intelligentFormat(numericAmount, currency);
    },
    /**
     * formats item price with currency and local thousands and decimal separators.
     * @param {string} options.currency currency to which this item's price will be formatted.
     * @param {boolean} options.includeCurrencySymbol if false, the currency symbol will be omitted from the return value.
     * @returns {string} local-formatted price string, when options is {currency: "EUR", includeCurrencySymbol: true} and item price is 123456.78, returns "€123.456,78".
     */
    localizedAmount: function (options) {
        var convertedAmounts = this.get('convertedAmounts');
        if (!convertedAmounts) {
            return;
        }
        options = _.extend({
            currency: this.getCurrency(),
            includeCurrencySymbol: true
        }, options);
        return numberConversions.intelligentFormat(
            convertedAmounts.toJSON()[options.currency],
            options.currency,
            options
        );
    },
    negate: function () {
        var convertedAmounts = this.get('convertedAmounts').toJSON();
        this.set('amount', this.get('amount') * -1, { removeConvertedAmounts: false });
        _.each(convertedAmounts, function (val, currency) {
            this.get('convertedAmounts').set(currency, val * -1);
        }, this);
        return this;
    },
    safeNegate: function () {
        return this.clone().negate();
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/FinancialAmount.js
// module id = 10
// module chunks = 64